import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

export function ProfitMarginsWidget({ summary }) {
  if (!summary) return null;
  const periods = [
    { label: "This Week", data: summary.this_week, color: "text-blue-400" },
    { label: "This Month", data: summary.this_month, color: "text-violet-400" },
    { label: "This Year", data: summary.this_year, color: "text-primary" },
    { label: "Overall", data: summary.overall, color: "text-emerald-400" },
  ];

  return (
    <Card className="border-border" data-testid="profit-summary-widget">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold uppercase tracking-wider text-muted-foreground flex items-center gap-2">
          <TrendingUp className="w-4 h-4" /> Profit Margins
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {periods.map(({ label, data: s, color }) => (
            <div key={label} className="bg-secondary/30 rounded-lg border border-border p-4">
              <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-3">{label}</p>
              <div className="flex items-baseline gap-2 mb-2">
                <span className={`text-2xl font-bold ${s.margin >= 0 ? color : "text-red-400"}`} style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
                  {s.margin}%
                </span>
                <span className="text-xs text-muted-foreground">margin</span>
              </div>
              <div className="space-y-1 text-xs">
                <div className="flex justify-between"><span className="text-muted-foreground">Revenue</span><span className="font-medium text-primary">${s.revenue.toLocaleString()}</span></div>
                <div className="flex justify-between"><span className="text-muted-foreground">Expenses</span><span className="font-medium text-red-400">${s.expenses.toLocaleString()}</span></div>
                <div className="flex justify-between border-t border-border pt-1 mt-1">
                  <span className="text-muted-foreground font-semibold">Profit</span>
                  <span className={`font-bold ${s.profit >= 0 ? "text-emerald-400" : "text-red-400"}`}>${s.profit.toLocaleString()}</span>
                </div>
                <p className="text-muted-foreground/60 pt-1">{s.events} event{s.events !== 1 ? "s" : ""}</p>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
